
import { useAppStore } from "../context/state";
// return the user data from the session storage
export const getUser = () => {
    return useAppStore.getState().user
}

export const getLang = () => {
    return useAppStore.getState().language
}

// return the token from the session storage
export const getToken = () => {
    return useAppStore.getState().token
}

// return the token from the session storage
export const getLocale = () => {
    return useAppStore.getState().locale
}

// remove the token and user from the session storage
export const removeUserSession = () => {
    useAppStore.setState({ user: null })
    useAppStore.setState({ token: null })
    useAppStore.setState({ isAuth: false })
}

// set the token and user from the session storage
export const setUserSession = ( user ) => {
    useAppStore.setState({ user: user })
    useAppStore.setState({ token: user.token })
    useAppStore.setState({ isAuth: true })    
    useAppStore.setState({ current: new Date() })
}

export const saveStorageAuthors = (data) =>{
    const { books, offset, pages } = data;
    const authors = useAppStore.getState().localAuthors
        authors[offset]= {books, pages}
    useAppStore.setState({ localAuthors: authors })
}

export const getStorageAuthors = (offset) =>{
    const authors = useAppStore.getState().localAuthors
    return authors[offset]
}

export const saveStorageBooks = (data) =>{
    const { books, offset, pages } = data;
    const list = useAppStore.getState().localBooks
        list[offset]= {books, pages}
    useAppStore.setState({ localBooks: list })
}

export const getStorageBooks = (offset) =>{
    const books = useAppStore.getState().localBooks
    return books[offset]
}